import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  helpIcon: {
    marginLeft: theme.spacing(1),
  }
});

class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      osOrders: [],
      ttOrders: [],
      ttFiled: {},
    }

    this.getOsOrders = this.getOsOrders.bind(this);
    this.getTtOrders = this.getTtOrders.bind(this);
    this.getTtFilled = this.getTtFilled.bind(this);
  }

  componentDidMount() {
    this.getOsOrders()
    this.getTtOrders()
    this.timer = setInterval(()=> {
      this.getOsOrders()
      this.getTtOrders()
      this.getTtFilled()
    }, 15000);
  }

  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null;
  }

  getOsOrders = () => {
    fetch('https://api.opensea.io/wyvern/v1/orders?asset_contract_address=0x0e3a2a1f2146d86a604adc220b4967a898d7fe07&limit=100&side=1')
    .then(res => {
      return res.json()
    }).then(data => {
      let cards = data.orders.map((card) => {
        let asset = card.asset
        let proto_id = asset ? asset.image_url.replace('https://storage.opensea.io/gods-unchained-asset-images/v0_0/proto', '') : ''
        let quality = proto_id.substring(proto_id.indexOf('/quality') + 8)
        quality = quality.replace('.png', '')
        proto_id = proto_id.substring(0, proto_id.indexOf('/quality'))
        return(asset ? { proto: `${proto_id}-${quality}`, name: asset.name, tokenId: asset.token_id, thumbnail: asset.image_thumbnail_url, preview: asset.image_preview_url, price: card.current_price/1000000000000000000, time: card.created_date, marketplace: 'OpenSea'} : {})
      })
      this.setState({osOrders: cards})
    })
  }

  getTtOrders = () => {
    fetch('https://gy2601wgv6.execute-api.us-east-1.amazonaws.com/dev/all-orders?tokenAddress=0x0e3a2a1f2146d86a604adc220b4967a898d7fe07',{ 
      method: 'get', 
      headers: new Headers({
        'x-api-key': 'Np8BV2d5QR9TSFEr9EvF66FWcJf0wIxy2qBpOH6s', 
      }), 
    })
    .then(res => {
      return res.json()
    }).then(data => {
      let cards = data.map((card) => {
        let metadata = JSON.parse(card.metadata)
        let proto = card.token_proto.split('-')
        let thumbnail = `https://storage.opensea.io/gods-unchained-asset-images/v0_0/proto${proto[0]}/quality${proto[1]}-thumbnail.png`
        let preview = `https://storage.opensea.io/gods-unchained-asset-images/v0_0/proto${proto[0]}/quality${proto[1]}-preview.png`
        let date = new Date(card.created_at)
        date.setHours(date.getHours()+8)
        return({ proto: card.token_proto, name: metadata.name, tokenId: card.token_id, thumbnail: thumbnail, preview: preview, price: card.takerAssetAmount/1000000000000000000, time: date, marketplace: 'token-trove'})
      })
      cards.sort((a,b) => {
        let aDate = new Date(a.time)
        let bDate = new Date(b.time)
        return bDate.getTime() - aDate.getTime()
      })
      this.setState({ttOrders: cards.splice(0,100)})
    })
  }

  getTtFilled = () => {
    // fetch('https://gy2601wgv6.execute-api.us-east-1.amazonaws.com/dev/historical-prices?tokenAddress=0x0e3a2a1f2146d86a604adc220b4967a898d7fe07',{ 
    //   method: 'get', 
    //   headers: new Headers({
    //     'x-api-key': 'Np8BV2d5QR9TSFEr9EvF66FWcJf0wIxy2qBpOH6s', 
    //   }), 
    // })
    // .then(res => {
    //   return res.json()
    // }).then(data => {
    //   let cardsMap = {}

    //   data.forEach(card => {
    //     cardsMap[card.proto] = card.price/1000000000000000000
    //   })

    //   this.setState({ttFiled: cardsMap})
    // })
  }

  render() {
    const { classes } = this.props;
    let currentTime = new Date();
    let cards = [];
    cards.push(...this.state.osOrders);
    cards.push(...this.state.ttOrders);

    cards.sort((a,b) => {
      let aDate = new Date(a.time)
      let bDate = new Date(b.time)
      return bDate.getTime() - aDate.getTime()
    })

    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            {cards.length <= 0 &&
              <CircularProgress />
            }
            {cards.length > 0 &&
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {/* <TableCell></TableCell> */}
                    <TableCell></TableCell>
                    <TableCell>Name</TableCell>
                    {/* <TableCell>Buy</TableCell> */}
                    <TableCell>Marketplace</TableCell>
                    <TableCell>Price (ETH)</TableCell>
                    <TableCell>Time Past</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cards.map((card, index) => {
                    let cardTime = new Date(card.time);
                    cardTime.setHours(cardTime.getHours() - 8);

                    let diff = currentTime - cardTime;
                    let minutes = Math.floor(diff/60000);
                    let seconds = Math.floor(diff/1000);

                    // let valueOffer =  this.state.ttFiled[card.proto] - card.price >= .1
                    // console.log(index, card.name, this.state.ttFiled[card.proto], card.price, valueOffer)
                    return (
                      <TableRow hover key={index}>
                        {/* <TableCell>{index}</TableCell> */}
                        <TableCell><Avatar variant="square" alt={card.name} src={card.thumbnail} /></TableCell>
                        <TableCell>{card.name}</TableCell>
                        {/* <TableCell>{valueOffer && this.state.ttFiled[card.proto]}</TableCell> */}
                        <TableCell>{card.marketplace}</TableCell>
                        <TableCell>{card.price.toFixed(4)}</TableCell>
                        <TableCell>{minutes > 0 ? minutes + ' mins' : seconds + ' secs'}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            }
          </Paper>
        </Grid>
      </React.Fragment>
    );
  }
}

Orders.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Orders);